import React, { useState, useEffect, useRef, useContext } from 'react';
import './RemoteParking.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Header from '@/v2/components/application/Header';
import TimeController from '@/v2/components/controllers/TimeController';
import TimelineText from '@/v2/components/atoms/TimelineText';
import Fade from '@/v2/components/atoms/Fade';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DriverAssistContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';

const STATE = {
    none: 'none',
    intro: 'intro',
    video: 'video',
    end: 'end',
};

const videoReady = (controller, videoController, onReady) => {
    // eslint-disable-next-line no-param-reassign
    videoController.current = controller;
    onReady();
};

const stateIntro = (timeController, setTime, timeline, cb) => {
    // eslint-disable-next-line no-param-reassign
    timeController.current = new TimeController(setTime);
    timeController.current.AddTimeoutFromTimeline(timeline, () => cb());
};

const stateVideo = (videoController, timeController, timeline, cb) => {
    if (videoController && videoController.current) videoController.current.Play();
    timeController.current.AddTimeoutFromTimeline(timeline, () => cb());
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [state, setState] = useState(STATE.none);

    const videoController = useRef(null);
    const timeController = useRef(null);

    const time = useRef(TimelineText.Time());
    const [{ disclaimer }] = useContext(DriverAssistContext);

    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    useEffect(() => {
        if (isActive) setState(STATE.intro);
    }, [isActive]);

    useEffect(() => {
        if (isActive && videoController && videoController.current) {
            videoController.current.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController.current]);

    useEffect(() => {
        switch (state) {
            case STATE.intro:
                stateIntro(timeController, time.current.Set, data.text.timeline, () => setState(STATE.video));
                break;
            case STATE.video:
                stateVideo(videoController, timeController, data.text.secondaryTimeline, () => setState(STATE.end));
                break;
            case STATE.end:
                onFinished();
                break;
            default:
        }
    }, [state]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, videoController, onReady),
        autoPlay: false,
    };

    const timeline = state === STATE.video ? data.text.secondaryTimeline : data.text.timeline;
    const disclaimerContent = disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    return (
        <div className="RemoteParking">
            <VideoSimple src={data.video} options={options} />
            <Header show hideLogo dark />
            <TimelineText data={timeline} time={time.current} key={`timeline-${state}`} background="dark" color="black" />
            <Fade show={!isActive} light cover />
            {disclaimerContent}
        </div>
    );
};
